import { Button } from 'react-bootstrap';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { FaCartPlus, FaCheck, FaWhatsapp } from 'react-icons/fa6';
import '../../assets/styles/action-feedback.css';
import { feedbackClassName } from '../../hooks/useActionFeedback';
import { Link } from 'react-router-dom';
import { LuShare } from 'react-icons/lu';
import { MdOutlinePreview } from 'react-icons/md';
import { FaEllipsisV } from 'react-icons/fa';
import QuantitySelector from '../ui/QuantitySelector';
import '../../assets/styles/product.modal.footer.css';
import { handleShare, handleWhatsApp } from '../../utils/productUtils';

const ProductModalFooter = ({
    product,
    addToCart,
    disabled,
    feedback = null,
    layout = 'stacked',
    quantityValue,
    quantityMax,
    onQuantityChange,
}) => {
    const isInlineLayout = layout === 'inline';
    const renderAddToCartButton = (buttonClassName = '') => (
        <Button
            variant="primary"
            onClick={() => addToCart()}
            className={`fw-bold d-flex align-items-center justify-content-center gap-2 rounded-3 shadow-sm ${buttonClassName} ${feedback === 'success' ? 'is-added' : ''} ${feedbackClassName(feedback)}`}
            disabled={product.countInStock === 0 || disabled || feedback === 'pending' || feedback === 'success'}
            style={{ fontSize: isInlineLayout ? '0.82rem' : '0.9rem' }}
        >
            {feedback === 'success' ? <FaCheck size={18} /> : <FaCartPlus size={18} />}
            {disabled ? 'Pago en Proceso' : feedback === 'success' ? 'Agregado' : 'Agregar al Carrito'}
        </Button>
    );

    return (
        <>
            <div
                className={
                    isInlineLayout
                        ? 'modal-footer-inline-row d-flex align-items-center gap-2 w-100'
                        : 'd-flex align-items-center gap-2 w-100'
                }
            >
                {isInlineLayout && (
                    <div className="modal-footer-inline-qty">
                        <QuantitySelector
                            value={quantityValue}
                            max={quantityMax}
                            onChange={onQuantityChange}
                            size="md"
                            density="compact"
                        />
                    </div>
                )}

                {isInlineLayout ? (
                    <div className="modal-footer-inline-cart flex-grow-1">
                        {renderAddToCartButton('w-100 py-2 modal-footer-inline-cart-btn')}
                    </div>
                ) : (
                    renderAddToCartButton('flex-grow-1 py-2')
                )}

                <DropdownMenu.Root>
                    <DropdownMenu.Trigger asChild>
                        <Button
                            variant="outline-secondary"
                            className="modal-footer-menu-btn p-2 d-flex align-items-center justify-content-center rounded-3"
                            style={{ height: '100%', aspectRatio: '1/1' }}
                            aria-label="Más opciones"
                        >
                            <FaEllipsisV size={18} />
                        </Button>
                    </DropdownMenu.Trigger>

                    <DropdownMenu.Portal>
                        <DropdownMenu.Content
                            className="dropdown-menu-custom"
                            sideOffset={8}
                            align="end"
                        >
                            <DropdownMenu.Item asChild>
                                <button
                                    className="dropdown-item"
                                    onClick={() => handleShare(product)}
                                >
                                    <LuShare size={18} className="me-2" />
                                    Compartir
                                </button>
                            </DropdownMenu.Item>

                            <DropdownMenu.Item asChild>
                                <button
                                    className="dropdown-item"
                                    onClick={() => handleWhatsApp(product)}
                                >
                                    <FaWhatsapp size={18} className="me-2 text-success" />
                                    Ayuda
                                </button>
                            </DropdownMenu.Item>

                            <DropdownMenu.Item asChild>
                                <Link className="dropdown-item" to={`/product/${product._id}`}>
                                    <MdOutlinePreview size={18} className="me-2" />
                                    Ver Detalle
                                </Link>
                            </DropdownMenu.Item>
                        </DropdownMenu.Content>
                    </DropdownMenu.Portal>
                </DropdownMenu.Root>
            </div>
        </>
    );
};

export default ProductModalFooter;
